// vim: set ts=2 sts=2 sw=2 et:

import React from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

type Props = {
  show: boolean;
  currentMeetName: string;
  newMeetName: string;
  onCancel: () => void;
  onConfirm: () => void;
};

const WrpfSwitchTournamentModal = ({ show, currentMeetName, newMeetName, onCancel, onConfirm }: Props) => {
  return (
    <Modal show={show} onHide={onCancel} backdrop="static" keyboard={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cambiar de torneo en OpenLifter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="danger">
          <Alert.Heading className="h5">Se va a borrar el progreso del torneo que tenés cargado</Alert.Heading>
          <p className="mb-0">
            Intentos marcados, pesajes, orden de flights y cualquier cambio sin guardar en{" "}
            <strong>{currentMeetName || "el torneo actual"}</strong> se perderán si continuás.
          </p>
        </Alert>
        <p className="mb-2">
          Vas a cargar <strong>{newMeetName}</strong> desde WRPF Argentina.
        </p>
        <p className="mb-0 text-muted">
          Para retomar más tarde, guardá un archivo <code>.openlifter</code> desde la pantalla de inicio de OpenLifter
          antes de cambiar de torneo.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onCancel}>
          Cancelar — seguir en el torneo actual
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Sí, cargar {newMeetName}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WrpfSwitchTournamentModal;
